<svelte:options namespace="svg" />

<defs>
  <filter xmlns="http://www.w3.org/2000/svg" id="dropshadow-{uuid}" height="130%">
    <feGaussianBlur in="SourceAlpha" stdDeviation="2"/>
    <feOffset dx="2" dy="2" result="offsetblur"/>
    <feComponentTransfer>
      <feFuncA type="linear" slope="0.175"/>
    </feComponentTransfer>
    <feMerge>
      <feMergeNode/>
      <feMergeNode in="SourceGraphic"/>
    </feMerge>
  </filter>
</defs>

<path data-name="border" filter="url(#dropshadow-{uuid})" d="M19.64,420.67H262.37a19.82,19.82,0,0,0,19.63-20v-163l0,0c10.3-3.46,17.81-15.61,18.13-27.25A28.37,28.37,0,0,0,282,183.08l0,0V20A19.81,19.81,0,0,0,262.37,0H19.64A19.82,19.82,0,0,0,0,20V400.66A19.82,19.82,0,0,0,19.64,420.67Z" fill="#fff" stroke="#8d939f"/>

<path data-name="logo" d="M280.15,207.91a2.3,2.3,0,0,1,1.85,1.26,2.33,2.33,0,0,1,1.86-1.26h.51a2.31,2.31,0,0,1,2,2.1c0,.19,0,.39,0,.58a2.57,2.57,0,0,1-.71,1.61L282,215.83l-3.64-3.62a2.53,2.53,0,0,1-.72-1.61c0-.19,0-.39,0-.58a2.31,2.31,0,0,1,2-2.1h.51m-4.47-6.7-3.78,8.14L282,219.46l10.11-10.11-3.78-8.14L282,207.52h0Z" style="fill: #ce2134;"/>

<script>
  import u from '../lib/uuidv4';

  const uuid = u();
</script>
